import { appLinks } from "../routes";

export const Logo = () => {
  return (
    <a href={appLinks.formlyApp} target="_blank">
      <svg
        width="154"
        height="52"
        viewBox="0 0 154 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M46.5147 42.3046C43.1038 42.3046 40.1955 41.1491 37.7896 38.838C35.4142 36.527 34.2265 33.6686 34.2265 30.2629C34.2265 26.8572 35.4142 23.9988 37.7896 21.6877C40.165 19.3767 43.0734 18.2212 46.5147 18.2212C49.956 18.2212 52.8643 19.3767 55.2397 21.6877C57.6151 23.9988 58.8028 26.8572 58.8028 30.2629C58.8028 33.6686 57.6151 36.527 55.2397 38.838C52.8643 41.1491 49.956 42.3046 46.5147 42.3046Z"
          fill="#FF9900"
        />
        <path
          d="M69.3412 23.2842C69.7675 21.7334 70.605 20.5322 71.8536 19.6808C73.1022 18.8294 74.5488 18.4036 76.1933 18.4036V27.5261C74.3661 27.2829 72.7672 27.6478 71.3968 28.6208C70.0264 29.5635 69.3412 31.0839 69.3412 33.1821V41.666H60.8902V18.8598H69.3412V23.2842Z"
          fill="#FF9900"
        />
        <path
          d="M105.3 18.2212C107.949 18.2212 110.02 19.0574 111.513 20.7299C113.005 22.3719 113.751 24.7286 113.751 27.7998V41.666H105.3V28.9401C105.3 27.2069 104.523 26.3402 102.97 26.3402C101.173 26.3402 100.275 27.4653 100.275 29.7155V41.666H91.824V28.9401C91.824 27.2069 91.0475 26.3402 89.4943 26.3402C87.6975 26.3402 86.7991 27.4653 86.7991 29.7155V41.666H78.3482V18.8598H86.7991V21.0036C88.2914 19.1487 90.3623 18.2212 93.0118 18.2212C95.6308 18.2212 97.5342 19.1639 98.7219 21.0492C100.366 19.1639 102.559 18.2212 105.3 18.2212Z"
          fill="#FF9900"
        />
        <path d="M116.25 41.666V8.3689H124.701V41.666H116.25Z" fill="#FF9900" />
        <path
          d="M142.962 18.8598H152.555L144.789 41.6204C143.662 44.9349 141.911 47.322 139.536 48.7816C137.16 50.2716 134.023 50.9406 130.125 50.7885V42.8063C131.678 42.8063 132.866 42.6847 133.688 42.4414C134.511 42.2286 135.165 41.8181 135.653 41.2099L126.517 18.8598H136.11L140.175 31.0383L142.962 18.8598Z"
          fill="#FF9900"
        />
        <path
          d="M46.5147 42.3046C43.1038 42.3046 40.1955 41.1491 37.7896 38.838C35.4142 36.527 34.2265 33.6686 34.2265 30.2629C34.2265 26.8572 35.4142 23.9988 37.7896 21.6877C40.165 19.3767 43.0734 18.2212 46.5147 18.2212C49.956 18.2212 52.8643 19.3767 55.2397 21.6877C57.6151 23.9988 58.8028 26.8572 58.8028 30.2629C58.8028 33.6686 57.6151 36.527 55.2397 38.838C52.8643 41.1491 49.956 42.3046 46.5147 42.3046Z"
          stroke="#FCF9F8"
        />
        <path
          d="M69.3412 23.2842C69.7675 21.7334 70.605 20.5322 71.8536 19.6808C73.1022 18.8294 74.5488 18.4036 76.1933 18.4036V27.5261C74.3661 27.2829 72.7672 27.6478 71.3968 28.6208C70.0264 29.5635 69.3412 31.0839 69.3412 33.1821V41.666H60.8902V18.8598H69.3412V23.2842Z"
          stroke="#FCF9F8"
        />
        <path
          d="M105.3 18.2212C107.949 18.2212 110.02 19.0574 111.513 20.7299C113.005 22.3719 113.751 24.7286 113.751 27.7998V41.666H105.3V28.9401C105.3 27.2069 104.523 26.3402 102.97 26.3402C101.173 26.3402 100.275 27.4653 100.275 29.7155V41.666H91.824V28.9401C91.824 27.2069 91.0475 26.3402 89.4943 26.3402C87.6975 26.3402 86.7991 27.4653 86.7991 29.7155V41.666H78.3482V18.8598H86.7991V21.0036C88.2914 19.1487 90.3623 18.2212 93.0118 18.2212C95.6308 18.2212 97.5342 19.1639 98.7219 21.0492C100.366 19.1639 102.559 18.2212 105.3 18.2212Z"
          stroke="#FCF9F8"
        />
        <path
          d="M116.25 41.666V8.3689H124.701V41.666H116.25Z"
          stroke="#FCF9F8"
        />
        <path
          d="M142.962 18.8598H152.555L144.789 41.6204C143.662 44.9349 141.911 47.322 139.536 48.7816C137.16 50.2716 134.023 50.9406 130.125 50.7885V42.8063C131.678 42.8063 132.866 42.6847 133.688 42.4414C134.511 42.2286 135.165 41.8181 135.653 41.2099L126.517 18.8598H136.11L140.175 31.0383L142.962 18.8598Z"
          stroke="#FCF9F8"
        />
        <path
          d="M7.9902 33.5759L7.99196 33.6695C8.04114 38.4849 9.07343 42.6578 14.3941 42.659C17.7199 42.6596 22.3398 42.7648 23.2684 39.1076C24.2281 35.3288 23.8745 31.8307 23.8581 28.2501C23.8545 27.4812 24.0232 27.3122 24.7861 27.3029C28.8772 27.2514 32.5625 24.5607 32.5409 20.2522C32.5098 17.5229 29.8199 15.2046 27.1833 15.1889C26.0714 15.1824 28.0229 13.3641 28.4855 12.811C35.1617 4.82245 28.3819 -0.664791 19.5269 0.710966C12.6452 1.77976 8.21446 6.5648 8.10614 13.4477C8.06866 15.8186 7.72847 15.3239 5.21538 15.6028C-2.00011 16.4044 -0.563216 27.4023 6.99656 27.3748H7.11893C7.58794 27.3748 7.96854 27.7537 7.97088 28.222L7.99196 33.5765L7.9902 33.5759Z"
          fill="#FF9900"
          stroke="#FCF9F8"
        />
        <path
          d="M18.7924 18.465C18.7924 19.849 17.8895 20.9706 16.9344 20.9706C15.8612 20.9706 14.9913 19.849 14.9913 18.465C14.9913 17.0811 15.9969 15.9595 16.9344 15.9595C18.0077 15.9595 18.7924 17.0811 18.7924 18.465Z"
          fill="#FCF9F8"
        />
        <path
          d="M23.5438 18.6005C23.5438 19.9845 22.6119 21.1061 21.5247 21.1061C20.4375 21.1061 19.607 19.9845 19.607 18.6005C19.607 17.2166 20.6008 16.095 21.5247 16.095C22.6727 16.095 23.5438 17.2166 23.5438 18.6005Z"
          fill="#FCF9F8"
        />
      </svg>
    </a>
  );
};
